<section class="section-product-hero">
  <div class="section-container">
    <div class="product-hero-content-box">
      <div>
        <span class="product-hero-subheading mar-b-16"
          >{{ heroData?.tags?.[0]?.fields?.tagText }}
        </span>
        <h1 class="product-hero-header">
          {{ heroData?.title }}
        </h1>
        <div
          class="landing-hero-content mar-t-24"
          [innerHtml]="heroData?.content | toHtml"
        ></div>
        <div class="landing-btn mar-t-48 align-c">
          <app-common-talktosales-button
            [text]="heroData?.buttons?.[1]?.fields?.buttonText"
            [hubspotId]="heroData?.buttons?.[1]?.fields?.redirectLink"
          ></app-common-talktosales-button>
        </div>
      </div>
      <div class="display-f flex-end atlas-hero-wrapper">
        <img
          src="{{ heroData?.image?.[0]?.fields?.file?.url }}"
          alt="{{ heroData?.image?.[0]?.fields?.title }}"
        />
      </div>
    </div>
  </div>
</section>
